import { ArticleHeading4, IconButton, Image, UIText2, Avatar } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './SelectedSubAgent.css';
import { TSubAgent } from '../../types/subAgent';

type TSelectedSubAgentProps = {
  isTopTabsRedesigned: boolean;
  subAgent: TSubAgent;
  onClose: () => void;
};

export const SelectedSubAgent: React.FC<TSelectedSubAgentProps> = ({ subAgent, onClose, isTopTabsRedesigned }) => {
  const { name, agentAvatarUrl, lastOnlineStatus } = subAgent;

  return (
    <div className={isTopTabsRedesigned ? styles['container-redesigned'] : styles['container']}>
      {agentAvatarUrl ? (
        <Image
          src={agentAvatarUrl}
          alt="Фотография пользователя"
          borderRadius="50%"
          objectFit="cover"
          height={40}
          width={40}
        />
      ) : (
        <div className={styles['avatar']}>
          <Avatar size={40} type="user" />
        </div>
      )}
      <div className={styles['info']}>
        <ArticleHeading4>{name}</ArticleHeading4>
        <UIText2 color="gray60_100">{lastOnlineStatus}</UIText2>
      </div>
      <div data-name="SelectedSubAgent_close">
        <IconButton icon={<IconActionClose16 />} onClick={onClose} />
      </div>
    </div>
  );
};
